import React from "react";

const clp = (n) => "$" + Math.round(Number(n || 0)).toLocaleString("es-CL");

/** Cuadratura: pagos de crédito (Tarjeta Propia) recibidos en la caja y total general por medio. */
export default function CuadraturaCredito({ c, testid = "cuad" }) {
  if (!c || !(c.abonos_credito || []).length) return null;
  return (
    <div className="pt-2 space-y-1" data-testid={`${testid}-credito`}>
      <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Pagos de crédito recibidos</p>
      {c.abonos_credito.map((m) => (
        <div key={m.codigo} className="flex justify-between" data-testid={`${testid}-abono-${m.codigo}`}>
          <span>{m.nombre} <span className="text-slate-400">· {m.n}</span></span><span className="font-mono-num">{clp(m.monto)}</span>
        </div>
      ))}
      <div className="flex justify-between font-bold pt-1 border-t border-slate-200">
        <span>Total pagos de crédito</span><span className="font-mono-num" data-testid={`${testid}-abonos-total`}>{clp(c.abonos_total)}</span>
      </div>
      <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400 pt-2">Total general (ventas + pagos)</p>
      {c.total_general.map((m) => (
        <div key={m.codigo} className="flex justify-between"><span>{m.nombre}</span><span className="font-mono-num">{clp(m.monto)}</span></div>
      ))}
      <div className="flex justify-between font-bold pt-1 border-t border-slate-200">
        <span>Total recibido</span><span className="font-mono-num" data-testid={`${testid}-total-general`}>{clp(c.total_general_monto)}</span>
      </div>
    </div>
  );
}
